import { type AggRequest, type AggResponse, fetchAgg } from '../../../common/utils/fetch-agg';

const LOOM_FOLDER_BY_ID_OPERATION_NAME = 'LoomRovoFolderByIdQuery';
const folderByIdQuery = `
	query ${LOOM_FOLDER_BY_ID_OPERATION_NAME}($id: ID!) {
		loom_folder(id: $id) {
			id
			name
			parentSpaceId
		}
	}
`;

export type LoomFolderByIdQueryVariables = { id: string };
export type LoomFolderByIdQueryData = {
	loom_folder: {
		id: string;
		name: string;
		parentSpaceId?: string | null;
	} | null;
};
export type LoomFolderByIdQueryProps = Pick<
	AggRequest<LoomFolderByIdQueryVariables>,
	'aggAbsoluteUrl' | 'variables' | 'headers'
>;

export const loomFolderByIdQuery = ({
	variables,
	aggAbsoluteUrl,
	headers,
}: LoomFolderByIdQueryProps): Promise<AggResponse<LoomFolderByIdQueryData>> =>
	fetchAgg<LoomFolderByIdQueryVariables, LoomFolderByIdQueryData>({
		variables,
		aggAbsoluteUrl,
		headers,
		graphQuery: folderByIdQuery,
		operationName: LOOM_FOLDER_BY_ID_OPERATION_NAME,
	});
